import { gql } from '@apollo/client';

export const GET_SETTINGS_BY_TYPE = gql`
  query GetSettingsByType {
    getSettingsByType {
      id
      user_id
      type
      settings_value
      created_at
      updated_at
      deleted
    }
  }
`;

export const LOGIN = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      success
      message
      user {
        id
        login_name
        name
        created_at
        updated_at
      }
    }
  }
`;

export const LOGIN_TELEGRAM = gql`
  mutation LoginTelegram($input: TelegramLoginInput!) {
    loginTelegram(input: $input) {
      success
      message
      user {
        id
        login_name
        name
        created_at
        updated_at
      }
    }
  }
`;

export const GET_USER_EVENTS = gql`
  query GetUserEvents($input: GetUserEventsInput!) {
    getUserEvents(input: $input) {
      success
      message
      events {
        id
        name
        description
        status
        start_date
        end_date
      }
    }
  }
`;

export const GET_USER_ROLES_BY_EVENT = gql`
  query GetUserRolesByEvent($input: GetUserRolesByEventInput!) {
    getUserRolesByEvent(input: $input) {
      success
      roles {
        id
        name
        description
        chat_id
      }
    }
  }
`;

export const GET_PLACES_BY_EVENT = gql`
  query GetPlacesByEvent($input: GetPlacesByEventInput!) {
    getPlacesByEvent(input: $input) {
      success
      places {
        id
        name
        description
        geo_location {
          latitude
          longitude
        }
        loc_id
        loc_name
        distance
      }
    }
  }
`;

export const GET_INVENTORY_BY_PLACE = gql`
  query GetInventoryByPlace($input: GetInventoryByPlaceInput!) {
    getInventoryByPlace(input: $input) {
      success
      inventory {
        id
        name
        description
        icon
        place_id
        place_name
        place_description
        place_tags
        event_id
        event_name
        role_id
        role_name
      }
    }
  }
`;

export const GET_QUESTIONS_BY_INVENTORY = gql`
  query GetQuestionsByInventory($input: GetQuestionsByInventoryInput!) {
    getQuestionsByInventory(input: $input) {
      success
      questions {
        id
        question_text
        type
        role_id
        role_name
        mandatory
        lov_values
        attach_file
        attach_note
        priority
        attach_alert
        attach_task
        interval
        incident
        skip_check
        inventory_id
        inventory_name
        inventory_description
        inventory_icon
        event_id
        event_name
      }
    }
  }
`;

export const GET_QR_ASSIGNMENTS_DETAIL = gql`
  query GetQrAssignmentsDetail($input: GetQrAssignmentsDetailInput!) {
    getQrAssignmentsDetail(input: $input) {
      id
      qr_id
      geo_location {
        latitude
        longitude
      }
      latitude
      longitude
      event_id
      event_name
      place_id
      place_name
      inventory_id
      inventory_name
      note
      created_by
      created_at
      updated_by
      updated_at
      deleted_by
      deleted_at
    }
  }
`;

export const SUBMIT_ANSWERS = gql`
  mutation SubmitAnswers($input: SubmitAnswersInput!) {
    submitAnswers(input: $input) {
      success
      message
      checkIds
    }
  }
`;

export const CREATE_TASK = gql`
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      taskId
      message
      success
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTask($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      id
      title
      description
      check_id
      initiator_id
      assignee_id
      priority
      status
      start_time
      end_time
      created_at
      updated_at
    }
  }
`;

export const UPDATE_PLACE_LOCATION = gql`
  mutation UpdatePlaceLocation($input: UpdatePlaceLocationInput!) {
    updatePlaceLocation(input: $input) {
      success
      message
    }
  }
`;

export const CREATE_QR_ASSIGNMENT = gql`
  mutation CreateQrAssignment($input: CreateQrAssignmentInput!) {
    createQrAssignment(input: $input) {
      success
      message
    }
  }
`;

export const CHECK_QR_BINDING = gql`
  query CheckQrBinding($input: CheckQrBindingInput!) {
    checkQrBinding(input: $input) {
      bound
      message
      id
      tenant
    }
  }
`;

export const CREATE_TRACKER = gql`
  mutation CreateTracker($input: CreateTrackerInput!) {
    createTracker(input: $input) {
      success
      message
      tracker {
        id
        caseid
        tel_number
      }
    }
  }
`;

export const GET_USERS = gql`
  query GetUsers {
    getUsers {
      success
      message
      users {
        id
        login_name
        name
      }
    }
  }
`;

export const CONNECT_TRACKER = gql`
  mutation ConnectTracker($input: ConnectTrackerInput!) {
    connectTracker(input: $input) {
      success
      message
    }
  }
`;

export const UPSERT_PUSH_SUBSCRIPTION = gql`
  mutation UpsertPushSubscription($input: UpsertPushSubscriptionInput!) {
    upsertPushSubscription(input: $input) {
      success
      message
    }
  }
`;

export const DELETE_PUSH_SUBSCRIPTION = gql`
  mutation DeletePushSubscription($input: DeletePushSubscriptionInput!) {
    deletePushSubscription(input: $input) {
      success
      message
    }
  }
`;

export const TASK_INBOX_SNAPSHOT = gql`
  query TaskInboxSnapshot($input: TaskInboxSnapshotInput!) {
    taskInboxSnapshot(input: $input) {
      asAssigneeInProgress {
        taskId
        taskTitle
        taskStatus
        taskUpdatedAt
      }
      asInitiatorCompleted {
        taskId
        taskTitle
        taskStatus
        taskUpdatedAt
      }
    }
  }
`;

export const LIST_TASKS = gql`
  query ListTasks(
    $filters: [FilterInput!]
    $sort: SortInput
    $pagination: PaginationInput
    $search: String
  ) {
    listTasks(
      filters: $filters
      sort: $sort
      pagination: $pagination
      search: $search
      searchFields: ["task_title", "event_name"]
    ) {
      total
      items {
        task_id
        task_title
        task_description
        task_priority
        task_status
        task_start_time
        task_end_time
        task_created_at
        task_updated_at
        initiator_id
        initiator_name
        initiator_login
        assignee_id
        assignee_name
        assignee_login
        check_id
        check_datetime
        group_id
        event_id
        event_name
        check_user_id
        check_user_name
        check_user_login
        inventory_id
        inventory_name
        inventory_description
        inventory_icon
        question_id
        question_text
        question_type
        question_mandatory
        question_attach_file
        question_attach_task
        question_incident
        role_id
        role_name
        place_id
        place_name
        place_location_names
        is_alert
        skip_check
        device_number
        check_note
        val_boolean
        val_text
        val_number
        val_real
        val_lov
        val_file
        value_type
        value_text
        value_numeric
        value_boolean
      }
    }
  }
`;
